import React, { useState } from "react";
import Cookies from "js-cookie";
import i18n from "config/i18n";

const LanguageToggle = () => {
  const [selectedLang, setSelectedLang] = useState(i18n.language);

  const changeLanguageAction = (lang) => {
    i18n.changeLanguage(lang);

    // Set cookie for all subdomains
    Cookies.set("I18N_LANGUAGE", lang, {
      // domain: "",
      path: "/",
      expires: 365,
      sameSite: "Lax",
    });

    const htmlEl = document.documentElement;
    if (lang === "ar") {
      htmlEl.setAttribute("dir", "rtl");
      htmlEl.setAttribute("id", "rtl");
    } else {
      htmlEl.setAttribute("dir", "ltr");
      htmlEl.setAttribute("id", "ltr");
    }

    setSelectedLang(lang);
  };
  return (
    <div className="language_toggle" role="group" aria-label="Switch language">
      <button
        type="button"
        className={`language_toggle_option${selectedLang === "en" ? " active" : ""}`}
        onClick={() => changeLanguageAction("en")}
        aria-pressed={selectedLang === "en"}
        title="Switch language to English"
      >
        EN
      </button>
      <button
        type="button"
        className={`language_toggle_option${selectedLang === "ar" ? " active" : ""}`}
        onClick={() => changeLanguageAction("ar")}
        aria-pressed={selectedLang === "ar"}
        title="Switch language to Arabic"
      >
        AR
      </button>
    </div>
  );
};

export default LanguageToggle;
